import { axiosIdentity } from './axiosInstances'
import { AxiosResponse } from 'axios'

export const getTags = (): Promise<AxiosResponse<string[]>> => {
  return axiosIdentity.get(`/tags`)
}
